import { useEffect, useState, useRef } from "react"
import { Row, Col } from "react-bootstrap"
import API from "components/Apis/API"
import * as d3 from "d3"

const BarChart = ({ data, title, screeWidth }) => {
  const svgRef = useRef()

  useEffect(() => {
    if (data && data.length > 0) {
      const svg = d3.select(svgRef.current)
      const margin = { top: 50, right: 30, bottom: 60, left: 90 }
      const width = screeWidth * 0.4 - margin.left - margin.right
      const height = 400 - margin.top - margin.bottom
      const x = d3
        .scaleBand()
        .domain(data.map((d) => d.label))
        .range([0, width])
        .padding(0.1)
      const y = d3
        .scaleLinear()
        .domain([0, d3.max(data, (d) => d.value)])
        .range([height, 0])
      svg.selectAll("*").remove()
      svg
        .append("g")
        .attr("transform", `translate(${margin.left},${margin.top})`)
        .selectAll("rect")
        .data(data)
        .enter()
        .append("rect")
        .attr("x", (d) => x(d.label))
        .attr("y", (d) => y(d.value))
        .attr("width", x.bandwidth())
        .attr("height", (d) => height - y(d.value))
        .attr("fill", "#69b3a2")
      const xAxis = svg
        .append("g")
        .attr("transform", `translate(${margin.left},${height + margin.top})`)
        .call(
          d3
            .axisBottom(x)
            .tickSizeOuter(0)
            .tickFormat((d) => (title !== "count" ? `${d}%` : d))
        )
      xAxis
        .selectAll("text")
        .style("text-anchor", "end")
        .attr("transform", "rotate(-45)")
      svg
        .append("g")
        .attr("transform", `translate(${margin.left},${margin.top})`)
        .call(d3.axisLeft(y).tickSizeOuter(0))
      svg
        .append("text")
        .attr(
          "transform",
          `translate(${width / 2 + margin.left}, ${margin.top / 2})`
        )
        .attr("text-anchor", "middle")
        .style("font-size", "16px")
        .text(
          title === "count"
            ? "User Feedback Count "
            : "Difference % in Predictions"
        )
    }
  }, [data, screeWidth])

  return <svg ref={svgRef} width={screeWidth * 0.4} height={400} />
}

const Displays = ({ width }) => {
  const [feedbackCount, setFeedbackCount] = useState([])
  const [difference, setDifferences] = useState([])
  const getData = async () => {
    const url = "admin/prediction-records"
    const response = await API.postData(url, {})
    const data = response.data
    setFeedbackCount(data.feedback_count)
    setDifferences(data.difference)
  }
  useEffect(() => {
    getData()
  }, [])
  console.log(feedbackCount, difference)
  return (
    <Row>
      <Col>
        <BarChart data={feedbackCount} title={"count"} screeWidth={width} />
      </Col>
      <Col>
        <BarChart data={difference} title={"diff"} screeWidth={width} />
      </Col>
    </Row>
  )
}

export default Displays
